import { queryGraphQL } from 'common/util/query';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
import { node, nodeWithArgs, toQuery, toMutation } from 'common/util/queryHelper';

export const ACTIONS = {
    PART11_LOAD_GROUPS: 'PART11_LOAD_GROUPS',
    PART11_LOAD_GROUP: 'PART11_LOAD_GROUP',
    PART11_LOAD_DOCUMENT_TYPES_FOR_GROUP: 'PART11_LOAD_DOCUMENT_TYPES_FOR_GROUP',
    PART11_LOAD_AVAILABLE_USERS_FOR_GROUP: 'PART11_LOAD_AVAILABLE_USERS_FOR_GROUP',
    PART11_REMOVE_USER_FROM_GROUP: 'PART11_REMOVE_USER_FROM_GROUP',
    PART11_LOAD_AVAILABLE_TRAINING_CONTENT: 'PART11_LOAD_AVAILABLE_TRAINING_CONTENT',
    PART11_ADD_USER_TO_GROUP: 'PART11_ADD_USER_TO_GROUP',
    PART11_CLEAR_GROUPS_SCENE: 'PART11_CLEAR_GROUPS_SCENE',
    PART11_INITIALIZE_GROUP_SCENE_COMPLION: 'PART11_INITIALIZE_GROUP_SCENE_COMPLION',
    PART11_UPDATE_GROUP_PRIORITY: 'PART11_UPDATE_GROUP_PRIORITY',
};

export function initializeGroupsScene(institutionId) {
    const query = toQuery(nodeWithArgs('groups', {
        institutionId,
    }, [
        'id',
        'displayName',
        'description',
        'isSystem',
        'isSearchable',
        'priority',
        node('documentTypes', [
            'id',
            'displayName'
        ]),
        node('users', [
            'id',
            'displayName'
        ]),
        node('systemPermissions', [
            'permissions'
        ])
    ]));

    return dispatch => {
        return queryGraphQL(query).then(response => {
            if(response.errors){
                dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
            }
            else {
                dispatch({
                    type: ACTIONS.PART11_INITIALIZE_GROUP_SCENE_COMPLION,
                    payload: response.data
                });
            }
        });
    };
}

export function loadGroups(institutionId) {
    const groupNode = nodeWithArgs('groups', {
        institutionId,
    }, [
        'id',
        'displayName',
    ]);

    const query = toQuery(groupNode);

    return dispatch => {
        return queryGraphQL(query).then(results => {
            dispatch({
                type: ACTIONS.PART11_LOAD_GROUPS,
                payload: {
                    groups: results.data.groups,
                }
            });
        });
    };
}

export function initializeGroupScene(groupId, institutionId) {
    const queries = toQuery([
        nodeWithArgs('group', {
            id: groupId,
            institutionId,
        }, [
            'id',
            'displayName',
            'description',
            'institutionId',
            'isSystem',
            node('trainingContent', [
                'id',
                'displayName',
                'description',
                'fileFormat',
                'url'
            ]),
            node('users', [
                'id',
                'displayName',
                'firstName',
                'lastName',
                'emailAddress'
            ]),
            node('documentTypes', ['id'])
        ]),
        nodeWithArgs('users', {
            institutionId
        }, [
            'id',
            'displayName',
            'firstName',
            'lastName',
            'emailAddress'
        ]),
        nodeWithArgs('documentTypes', {
            institutionId
        }, [
            'id',
            'name',
            'displayName'
        ])
    ]);

    return dispatch => {
        return queryGraphQL(queries).then(results => {
            if (results.errors) {
                dispatch(addApplicationMessages('error', results.formattedErrors));
            } else {
                const groupAction = {
                    type: ACTIONS.PART11_LOAD_GROUP,
                    payload: { group: results.data.group }
                };
                dispatch(groupAction);

                const usersAction = {
                    type: ACTIONS.PART11_LOAD_AVAILABLE_USERS_FOR_GROUP,
                    payload: { users: results.data.users }
                };
                dispatch(usersAction);

                const documentTypesAction = {
                    type: ACTIONS.PART11_LOAD_DOCUMENT_TYPES_FOR_GROUP,
                    payload: { documentTypes: results.data.documentTypes }
                };
                dispatch(documentTypesAction);
            }
        });
    };
}

export function addUserToGroup(user, group) {
    const groupNode = nodeWithArgs('addUserToGroup', {
        userId: user.id,
        groupId: group.id,
    }, [
        'id',
        'displayName',
        'description',
        'institutionId',
        'isSystem',
        'permissions',
        node('users', ['id', 'displayName', 'emailAddress']),
    ]);

    const mutation = toMutation(groupNode);

    return dispatch => {
        return queryGraphQL(mutation).then(results => {
            dispatch({
                type: ACTIONS.PART11_LOAD_GROUP,
                payload: {
                    group: results.data.addUserToGroup
                }
            });
        });
    };
}

export function removeUserFromGroup(user, group) {
    const groupNode = nodeWithArgs('removeUserFromGroup', {
        userId: user.id,
        groupId: group.id,
    }, [
        'id',
        'displayName',
        'description',
        'institutionId',
        'isSystem',
        'permissions',
        node('users', ['id', 'displayName', 'emailAddress']),
    ]);

    const mutation = toMutation(groupNode);

    return dispatch => {
        return queryGraphQL(mutation).then(results => {
            dispatch({
                type: ACTIONS.PART11_LOAD_GROUP,
                payload: {
                    group: results.data.removeUserFromGroup
                }
            });
        });
    };
}

export function clearGroupsScene() {
    return { type: ACTIONS.PART11_CLEAR_GROUPS_SCENE };
}
